const fontSets = {
  iconFont: 'IconFont',
  condensedMedium: '"main-condensed_regular", Roboto, sans-serif',
  condenseBold: '"main-condensed_regular", Roboto, sans-serif',
  narrow: '"main-condensed_regular", Roboto, sans-serif',
  narrowBold: '"main-condensed_bold", Roboto, sans-serif',
  narrowMedium: '"main-condensed_semibold", Roboto, sans-serif',
  narrowRegular: '"main-condensed_regular", Roboto, sans-serif',
  BreraRegular: '"BreraRegular", Roboto, sans-serif',
  BreraHeavy: '"main-heavy", Roboto, sans-serif',
  BrearaBold: '"BreraBold", Roboto, sans-serif',
  BreraCondensedRegular: '"main-condensed_regular", Roboto, sans-serif',
  BreraCondensedBold: '"main-condensed_bold", Roboto, sans-serif',
  BreraCondensedItalic: '"main-condensed_bold_italic", Roboto, sans-serif',
  BreraCondensedBlack: '"main-condensed_black", Roboto, sans-serif',
  BreraCondensedHeavy: '"main-condensed_heavy", Roboto, sans-serif',
  BreraCondensedSemibold: '"main-condensed_semibold", Roboto, sans-serif',
  BreraCondensedSemiboldItalic:
    '"main-condensed_semibold_italic", Roboto, sans-serif',
  BreraSemibold: '"main-semibold", Roboto, sans-serif',
  BreraCondensedLight: '"main-condensed_light", Roboto, sans-serif',
  BreraCondensedLightItalic:
    '"main-condensed_light_italic", Roboto, sans-serif',
  BreraThin: '"main-condensed_thin", Roboto, sans-serif',
  BreraLight: '"main-light", Roboto, sans-serif',
  Roboto: '"Roboto-Regular", sans-serif',
  PTSerif: '"PT Serif", Roboto, sans-serif',
  inherit: 'inherit',
};

export default fontSets;



// WEBPACK FOOTER //
// ./src/theme/corriere/fonts.js